// extracted by mini-css-extract-plugin
module.exports = {"h5button":"gy","h5Button":"gy","button":"gz","block":"gA","btnDefault":"gB","disable":"gC","btnPrimary":"gD"};